import * as React from "react";
const SvgUser = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 51 45",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fill: "currentColor",
	d: "M45 37.9c-.3.6-.8 1.1-1.4 1.4s-1.3.5-2 .6c-1.5.2-3.1.3-4.6.2H14c-1.5.1-3.1 0-4.6-.2-.7-.1-1.3-.3-2-.6-.6-.3-1.1-.8-1.4-1.4-.3-.8-.3-1.6 0-2.3.4-.9.8-1.7 1.4-2.4.1-.2.3-.4.4-.5 3.4-4.2 9-6.9 14.3-7.6 4.8-.7 9.8.2 14.1 2.4 4.7 2.5 6.7 5.2 6.7 5.2.2.2.3.4.4.5.6.7 1.1 1.6 1.4 2.4.6.7.6 1.5.3 2.3M25.5 23.4a9.1 9.1 0 1 0 0-18.2 9.1 9.1 0 0 0 0 18.2"
}));
export default SvgUser;
